/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WebApiAdminDtoLoginAsMemberDto
 */
export interface WebApiAdminDtoLoginAsMemberDto {
    /**
     * 
     * @type {number}
     * @memberof WebApiAdminDtoLoginAsMemberDto
     */
    companyId?: number;
    /**
     * 
     * @type {number}
     * @memberof WebApiAdminDtoLoginAsMemberDto
     */
    memberId?: number;
}

/**
 * Check if a given object implements the WebApiAdminDtoLoginAsMemberDto interface.
 */
export function instanceOfWebApiAdminDtoLoginAsMemberDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiAdminDtoLoginAsMemberDtoFromJSON(json: any): WebApiAdminDtoLoginAsMemberDto {
    return WebApiAdminDtoLoginAsMemberDtoFromJSONTyped(json, false);
}

export function WebApiAdminDtoLoginAsMemberDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiAdminDtoLoginAsMemberDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'companyId': !exists(json, 'companyId') ? undefined : json['companyId'],
        'memberId': !exists(json, 'memberId') ? undefined : json['memberId'],
    };
}

export function WebApiAdminDtoLoginAsMemberDtoToJSON(value?: WebApiAdminDtoLoginAsMemberDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'companyId': value.companyId,
        'memberId': value.memberId,
    };
}

